module.exports = __webpack_public_path__ + "img/symbol_13_x20.559b2d5e.png";